<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import rosenHoukouApi from 'src/apis/masters/rosen_houkou'

const api = rosenHoukouApi
const displayPageName = '路線方向'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        showAll: true,
        rosenId: null,
      },
      origList: [],
      list: [],
      origRosenCands: [],
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    rosenCands() {
      if (this.search.showAll) { return this.origRosenCands }

      return this.origRosenCands.filter(e => {
        const today = new Date()
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= today) && (today < endDt)
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.origRosenCands = master.rosen.vals
    },
    prepareSearchParams() {
      const search = {
        showAll: true,
        rosenId: null,
      }
      if (this.origRosenCands.length > 0) {
        search.rosenId = this.origRosenCands[0].m_rosen_id
      }
      this.search = search
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      this.list = this.origList.filter(e => e.rosen_id === this.search.rosenId)
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await rosenHoukouApi.index()
        this.origList = data
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    onShowAllChange() {
      let rosen = this.rosenCands.find(e => {
        return e.m_rosen_id === this.search.rosenId
      })
      if (!rosen) {
        rosen = this.rosenCands[0]
        this.search.rosenId =
          rosen ? rosen.m_rosen_id : null
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.rosen_id = this.search.rosenId
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
